import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Stack,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import USCLogoHeader from "../../components/USCLogoHeader";
import ClickableRedCard from "../../components/ClickableRedCard";
import "bootstrap/dist/css/bootstrap.min.css";
import YellowButton from "../../components/YellowButton";
import "./StudentSignIn.css";
import { getAvailableRoomsAPI } from "../../util/API";

function StudentSignIn({ onlyCase }) {
    const navigate = useNavigate();
    let [roomAvailability, setRoomAvailability] = useState([]);
    let [selectedBuilding, setSelectedBuilding] = useState();
    let [selectedRooms, setSelectedRooms] = useState([]);
    const { first, last, session } = useParams();

    useEffect(() => {
        getAvailableRoomsAPI((response) => {
            setRoomAvailability(response);
        });
    }, []);

    let toggleBuildingSelection = (building) => {
        setSelectedRooms([]);
        if (building === selectedBuilding) {
            setSelectedBuilding();
        } else {
            setSelectedBuilding(building);
        }
    };

    let toggleRoomSelection = (room) => {
        if (room === selectedRooms) {
          setSelectedRooms([]);
        } else {
          setSelectedRooms(room);
        }
    };


    let startSession = () => {
  
      if (onlyCase == true) {
        console.log("go to case");
        navigate(`/student/case/${first}/${last}/${session}/${selectedBuilding}/${selectedRooms}`);
      } else if (onlyCase == false) {
        console.log("go to survey");
        navigate(
          `/student/survey-in-elc/${first}/${last}/${session}/${selectedBuilding}/${selectedRooms}`
        );
      }
  
    };

    return (
        <div id="stu-signin-border">
            <USCLogoHeader />
            <p id="stu-signin-title">Student Sign In</p>
            <Row className="mx-5 pb-5 px-5 pt-5">
                <Col
                    lg={{ span: 3, offset: 2 }}
                    md={{ span: 4, offset: 2 }}
                    xs={{ span: 10, offset: 1 }}
                >
                    <div className="adminroomselect-labels mb-2">
                        Select Building
                    </div>
                    <Stack gap={3}>
                        {roomAvailability.map((obj, index) => {
                            return (
                                <ClickableRedCard
                                    key={index}
                                    text={obj.building}
                                    hasBorder={
                                        selectedBuilding === obj.building
                                    }
                                    onClick={() =>
                                        toggleBuildingSelection(obj.building)
                                    }
                                />
                            );
                        })}
                    </Stack>
                </Col>
                <Col
                    lg={{ span: 3, offset: 2 }}
                    md={{ span: 4, offset: 0 }}
                    xs={{ span: 10, offset: 1 }}
                >
                    <div className="adminroomselect-labels mb-2">
                      Select Room
                    </div>
                    <Rooms
                        roomAvailability={roomAvailability}
                        building={selectedBuilding}
                        selectedRooms={selectedRooms}
                        onRoomClick={toggleRoomSelection}
                    />
                </Col>
            </Row>
            <div
                className="adminroomselect-next-btn"
                hidden={selectedRooms.length === 0}
            >
                <YellowButton
                    text={"Next"}
                    width="120px"
                    onClick={startSession}el
                />
            </div>
        </div>
    );
}

let Rooms = ({
    roomAvailability,
    building,
    selectedRooms,
    onRoomClick,
    onBreakoutRoomChange,
}) => {
    const { first, last, session } = useParams();
    for (let i = 0; i < roomAvailability.length; i++) {
        let currBuilding = roomAvailability[i].building;
        if (building === currBuilding) {
            return (
                <Stack className="adminroomselect-scroll" gap={3}>
                    {roomAvailability[i].rooms.map((room, index) => {
                        let currSession = room.currentSession;
                        if (currSession != undefined && currSession != null && currSession.sessionId === session && currSession.firstName === first && currSession.lastName === last) {
                            return (
                                <ClickableRedCard
                                    key={index}
                                    text={room.name}
                                    hasBorder={selectedRooms.includes(
                                        room.name
                                    )}
                                    onClick={() => onRoomClick(room.name)}
                                />
                            );        
                        } else {
                            return <></>
                        }
                    })}
                </Stack>
            );
        }
    }

    return <></>;
    
};



export default StudentSignIn;